import {
	AmbientLight,
	Camera,
	NormalBlending,
	PointLight,
	Scene,
	ShaderMaterial,
	Vector2,
} from "three";
import {
	EffectComposer,
} from "three/examples/jsm/postprocessing/EffectComposer";
import {
	OutlinePass,
} from "three/examples/jsm/postprocessing/OutlinePass";
import {
	RenderPass,
} from "three/examples/jsm/postprocessing/RenderPass";
import {
	ShaderPass,
} from "three/examples/jsm/postprocessing/ShaderPass";
import {
	FXAAShader,
} from "three/examples/jsm/shaders/FXAAShader";

import {
	GltfSceneConfig,
} from "./gltf_scene_config";
import {
	Web3dModel,
} from "./web3d_model";
import {
	Web3dScene,
} from "./web3d_scene";
import {
	WStrackballControls,
} from "./wstrackballcontrols";

// Note: this has to be a separate class because object literals don't play nice with custom properties
export class DefaultGltfSceneConfig implements GltfSceneConfig
{
	private pointLight = new PointLight(0xf0f0f0, 1, 100000);
	// TODO: should this be a property?
	// private ambientLight = new AmbientLight(0x606060);
	private ambientLight = new AmbientLight(0xffffff, 1.5);

	private fxaaPass = new ShaderPass(FXAAShader);
	private outlinePass?: OutlinePass;
	private composer?: EffectComposer;

	controls?: WStrackballControls;

	initScene(scene: Web3dScene)
	{
		scene.scene.add(this.pointLight);
		scene.scene.add(this.ambientLight);

		const composer = new EffectComposer(scene.renderer);
		this.composer = composer;

		const renderPass = new RenderPass(scene.scene, scene.camera);
		composer.addPass(renderPass);

		const outlinePass = new OutlinePass(new Vector2(100, 100), scene.scene, scene.camera);
		this.outlinePass = outlinePass;
		outlinePass.overlayMaterial.blending = NormalBlending;
		outlinePass.edgeStrength = 8;
		outlinePass.edgeGlow = 0.1;
		outlinePass.edgeThickness = 2;
		outlinePass.pulsePeriod = 0;
		outlinePass.usePatternTexture = false;
		composer.addPass(outlinePass);

		composer.addPass(this.fxaaPass);

		this.controls = new WStrackballControls(scene.camera, scene.renderer.domElement);
	}

	modelLoaded(_model: Web3dModel<any>) {}

	resize(width: number, height: number, pixelRatio: number)
	{
		if (this.composer !== undefined) {
			this.composer.setSize(width, height);
		}
		if (this.outlinePass !== undefined) {
			this.outlinePass.resolution.x = width;
			this.outlinePass.resolution.y = height;
		}
		const material = this.fxaaPass.material;
		if (material instanceof ShaderMaterial) {
			material.uniforms["resolution"].value.x = 1 / (width / pixelRatio);
			material.uniforms["resolution"].value.y = 1 / (height / pixelRatio);
		}
	}

	beforeRender(_scene: Scene, camera: Camera)
	{
		if (this.controls !== undefined) {
			this.controls.update();
		}
		this.pointLight.position.copy(camera.position);
	}
}
